import React from "react";
import { DatePicker, TimePicker, Row, Form, Input } from "antd";
import { Visibility } from "../../../../../../shared";

export const ScheduleExpertServiceForm = ({
  form,
  maxHours,
  hoursPerDay,
  isService = false,
  readOnly = false
}) => {
  const hoursPerDayValidator = (_, value) => {
    if(!hoursPerDay || hoursPerDay === 0) {
      return Promise.resolve();
    }

    if(value > hoursPerDay)
      return Promise.reject(new Error());
    else
      return Promise.resolve();
  };

  return (
    <Form
      form={form}
      layout="vertical"
      style={{ width: "100%" }}>
      <Row>
        <Form.Item
          label="Fecha"
          name="serviceDate"
          style={{ marginRight: "27px" }}
          rules={[{ required: true }]}>
          <DatePicker
            disabled={readOnly}
            style={{ width: "235px" }} />
        </Form.Item>
        <Form.Item
          label="Hora"
          name="serviceHour"
          style={{ marginRight: "27px" }}
          rules={[{ required: true }]}>
          <TimePicker
            disabled={readOnly}
            showSecond={false}
            showNow={false}
            style={{ width: "235px" }} />
        </Form.Item>
        <Visibility visible={!isService}>
          <Form.Item
            label="Cantidad solicitada"
            initialValue={1}
            name="duration"
            rules={[{
              required: !isService,
              message: `Solo tienes ${hoursPerDay} horas disponibles por sesión`,
              validator: hoursPerDayValidator
            }]}>
            <Input
              disabled={readOnly}
              type="number"
              style={{ width: "235px" }}
              min={1}
              max={maxHours}
              step="1" />
          </Form.Item>
        </Visibility>
      </Row>
      <Form.Item
        name="comments"
        label="Cuéntanos un poco más sobre tu necesidad.">
        <Input.TextArea
          disabled={readOnly}
          placeholder="Por ejemplo: Ayuda para entender y segmentar mejor el mercado."
          rows={4} />
      </Form.Item>
    </Form>
  );
};
